import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedSidebar from '@/components/share/sidebar'
import CreateConversation from '@/graphql/chat/mutations/create-conversation.mutation'
import CreateMessage from '@/graphql/chat/mutations/create-message.mutation'
import UpdateConversation from '@/graphql/chat/mutations/update-conversation.mutation'
import axios from 'axios'
const slackUrl = 'https://hooks.slack.com/services/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'

export default {
  name: 'profile',
  components: {
    SharedHeader,
    SharedFooter,
    SharedSidebar
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    env () {
      return this.$store.getters.env
    },
    avatar () {
      return this.$store.getters.avatar
    },
    api () {
      return this.$store.getters.api
    }
  },
  data () {
    return {
      loading: true,
      avatarId: '',
      student: {},
      swiped: {},
      isAllSwiped: false,
      profile: {
        want: '',
        title: '',
        skill: []
      },
      theme: [],
      job: [],
      category: [
        {
          name: '会社情報',
          icon: ['fas', 'building'],
          description: ''
        },
        {
          name: '社員情報',
          icon: ['fas', 'portrait'],
          description: ''
        },
        {
          name: '職場情報',
          icon: ['fas', 'map-marker-alt'],
          description: ''
        },
        {
          name: '新卒採用情報',
          icon: ['fas', 'user-tie'],
          description: ''
        },
        {
          name: 'インターン採用情報',
          icon: ['fas', 'school'],
          description: ''
        },
        {
          name: 'イベント情報',
          icon: ['fas', 'bullhorn'],
          description: ''
        },
        {
          name: 'リリース情報',
          icon: ['fas', 'info-circle'],
          description: ''
        },
        {
          name: '記事情報',
          icon: ['fas', 'rss-square'],
          description: ''
        },
        {
          name: 'アルバイト採用情報',
          icon: ['fas', 'coffee'],
          description: ''
        }
      ],
      study: [],
      screening: {},
      badge: [],
      academicBackground: {},
      scout: {
        loading: false,
        isOpen: false,
        title: '興味をもっていただきありがとうございます！',
        message: 'はじめまして！株式会社＿＿の＿＿と申します！\nこの度は弊社のカードにご興味をお持ち頂きましてありがとうございます。\n＿＿さんのプロフィールを拝見しまして非常に興味を持っております。\nよろしければ一度、お気軽な感じで構いませんので、お話をしませんか？\n弊社や弊社のサービスをご紹介した上で、\n＿＿さんのやりたいことや興味のあることをお聞きできれば幸いです！\nよろしくお願い致します！',
        templateSave: false,
        selected: '',
        options: [
          {value: '', text: '選択してください'},
          {value: '1', text: '興味をもっていただきありがとうございます！'},
          {value: '2', text: 'ランチをしながらお話ししてみませんか？'}
        ],
        template: {
          1: {
            title: '興味をもっていただきありがとうございます！',
            message: 'はじめまして！株式会社＿＿の＿＿と申します！\nこの度は弊社のカードにご興味をお持ち頂きましてありがとうございます。\n＿＿さんのプロフィールを拝見しまして非常に興味を持っております。\nよろしければ一度、お気軽な感じで構いませんので、お話をしませんか？\n弊社や弊社のサービスをご紹介した上で、\n＿＿さんのやりたいことや興味のあることをお聞きできれば幸いです！\nよろしくお願い致します！'
          },
          2: {
            title: 'ランチをしながらお話ししてみませんか？',
            message: '初めまして。株式会社＿＿の＿＿と申します！\n弊社のカードに興味をもっていただいたこと、とても嬉しく思っております！\n＿＿様のプロフィールを拝見させていただき、とても魅力を感じました。\nよろしければ一度ランチでもしながらお話をしたいのですが、いかがでしょうか？\nお気軽な感じで構いませんので、よろしくお願いいたします！'
          }
        }
      },
      updating: false,
      modal: {
        isOpen: false,
        item: {}
      }
    }
  },
  methods: {
    getAvatar (id) {
      return `${this.env.S3}/student/avatar/${id}.png`
    },
    send () {
      this.updating = true

      let pathParams = {
        conversationId: 'new'
      }

      let additionalParams = {
        queryParams: {
          type: 'scout'
        }
      }

      let body = {
        studentId: this.$route.params.studentId,
        title: this.scout.title,
        message: this.scout.message,
        templateId: this.scout.selected,
        isTemplate: this.scout.templateSave
      }

      this.$apig.patch(this.api.CONTACT, pathParams, additionalParams, body)
        .then(response => {
          let conversationId = response.data.conversationId

          this.createConversation(conversationId, this.$route.params.studentId, this.scout.title)
            .then(() => {
              let content = this.scout.message
              this.sendMessage(conversationId, this.$route.params.studentId, content)
                .then(messageId => {
                  let room = {
                    id: conversationId,
                    user: {
                      id: this.user.enterpriseId,
                      name: this.user.name
                    },
                    opponent: {
                      id: this.$route.params.studentId,
                      name: this.student.nickname
                    },
                    title: this.scout.title
                  }
                  let message = {
                    id: messageId,
                    content
                  }
                  this.sendSlackHook(room, message)
                  this.$router.push(`/chat?id=${conversationId}`)
                })
            })
        })
        .catch(err => {
          console.log(err)
          this.error = err.response.data
          this.isAlert = true
          window.scrollTo(0, 0)
          this.updating = false
        })
    },
    async createConversation (conversationId, opponentId, title) {
      let updatedAt = new Date()
      let id = conversationId

      await this.$apollo.mutate({
        mutation: CreateConversation,
        variables: {
          input: {
            id,
            userId: this.user.enterpriseId,
            userType: 'ENTERPRISE',
            opponentId,
            opponentType: 'STUDENT',
            updatedAt,
            title
          }
        }
      })

      await this.$apollo.mutate({
        mutation: CreateConversation,
        variables: {
          input: {
            id,
            userId: opponentId,
            userType: 'STUDENT',
            opponentId: this.user.enterpriseId,
            opponentType: 'ENTERPRISE',
            updatedAt,
            title
          }
        }
      })
    },
    async sendMessage (conversationId, studentId, content) {
      const messageResponce = await this.$apollo.mutate({
        mutation: CreateMessage,
        variables: {
          input: {
            ownerId: this.user.enterpriseId,
            opponentId: studentId,
            conversationId,
            ownerType: 'ENTERPRISE',
            opponentType: 'STUDENT',
            content,
            createdAt: new Date()
          }
        }
      })

      await this.$apollo.mutate({
        mutation: UpdateConversation,
        variables: {
          input: {
            id: conversationId,
            userId: this.user.enterpriseId,
            lastMessageId: messageResponce.data.createMessage.id,
            updatedAt: new Date()
          }
        }
      })

      await this.$apollo.mutate({
        mutation: UpdateConversation,
        variables: {
          input: {
            id: conversationId,
            userId: studentId,
            lastMessageId: messageResponce.data.createMessage.id,
            updatedAt: new Date()
          }
        }
      })

      return messageResponce.data.createMessage.id
    },
    sendSlackHook (room, message) {
      let title = `[${this.env.STAGE}][企業]ルームを作成しました`
      let color = '#1e4573'

      const body = {
        attachments: [
          {
            fallback: title,
            color: color,
            fields: [
              {
                title: title,
                value: `ルームid: ${room.id}\n` +
                       `メッセージid: ${message.id}\n` +
                       `送信者: ${room.user.name}\n` +
                       `送信者id: ${room.user.id}\n` +
                       `受信者: ${room.opponent.name}\n` +
                       `受信者id: ${room.opponent.id}\n` +
                       `タイトル: ${room.title}\n` +
                       `内容: ${message.content}`
              }
            ]
          }
        ]
      }

      axios.post(slackUrl, JSON.stringify(body), { responseType: 'text' })
    },
    getCardCover (coverStatus, id) {
      if (!coverStatus) {
        return id
      } else if (coverStatus === 1) {
        return `${this.env.S3}/enterprise/swipe/${id}.png`
      }
    },
    openCard (item) {
      this.modal.item = item
      this.modal.isOpen = true
      this.$emit('modalOpen')
    },
    openMessage () {
      this.scout.loading = true
      this.scout.options = [
        {value: '', text: '選択してください'},
        {value: '1', text: '興味をもっていただきありがとうございます！'},
        {value: '2', text: 'ランチをしながらお話ししてみませんか？'}
      ]

      let pathParams = {
        conversationId: 'template'
      }

      let additionalParams = {
        queryParams: {
          type: 'template'
        }
      }

      this.$apig.get(this.api.CONTACT, pathParams, additionalParams, {})
        .then(response => {
          for (let templateId in response.data.template) {
            this.scout.template[templateId] = response.data.template[templateId]
            if (templateId === '1' || templateId === '2') this.scout.options[Number(templateId)].text = response.data.template[templateId].title
          }

          for (let item of response.data.options) {
            if (item.value !== '1' && item.value !== '2') this.scout.options.push(item)
          }

          if (!this.scout.selected) {
            this.scout.selected = '1'
            this.scout.title = this.scout.template['1'].title
            this.scout.message = this.scout.template['1'].message
          }

          this.scout.isOpen = true
          this.scout.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    setTemplate () {
      if (this.scout.selected) {
        this.scout.title = this.scout.template[this.scout.selected].title
        this.scout.message = this.scout.template[this.scout.selected].message
      } else {
        this.scout.title = ''
        this.scout.message = ''
      }
    }
  },
  mounted () {
    let additionalParams = {
      queryParams: {
        type: 'profile'
      }
    }

    let pathParams = {
      studentId: this.$route.params.studentId
    }

    this.$apig.get(this.api.STUDENT, pathParams, additionalParams, {})
      .then(response => {
        this.student = response.data
        this.swiped = response.data.swiped
        this.academicBackground = response.data.academicBackground
        if (response.data.profile) this.profile = response.data.profile
        if (response.data.theme) this.theme = response.data.theme
        if (response.data.job) this.job = response.data.job
        if (response.data.study) this.study = response.data.study
        if (response.data.screening) this.screening = response.data.screening
        this.badge = response.data.badgeList

        this.loading = false
      })
      .catch(err => {
        console.log(err)
        this.loading = false
        // TODO エラーページへ遷移
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/profile.js